<div *ngIf="isLoading">
    <app-spinner></app-spinner>
</div>


<div *ngIf="!isLoading">

    <div *ngIf="error">
        <app-errormessage
            [serverErrorMessage]="error.message"
            [errorMessageTranslationKey]="error.localizationKey">
        </app-errormessage>
    </div>

    <div *ngIf="allEvents && allEvents.length" class="container">
        <div class="row text-center mb-4">
            <div class="col-12">
                <h3 [appTranslate]="'AvailableEvents'">AvailableEvents</h3>
            </div>
        </div>
        <table class="table">
            <tbody>
            <tr class="preview-row" *ngFor="let event of allEvents">
                <td class="preview-row__title--column">
                    <ng-container
                        *ngIf="hasExternalLink(event) || hasInternalLink(); then linkTitle else staticTitle"></ng-container>
                    <ng-template #linkTitle>
                        <a [routerLink]="hasExternalLink(event) ? ['/externalRedirect'] : ['/internalRedirect']"
                           [queryParams]="hasExternalLink(event) ? { externalUrl: event.publicEventUrl} : { internalUrl: internalEventPage, id: event.readableEventId}">
                            <ng-container *ngTemplateOutlet="titleRow context: { event: event}"></ng-container>
                        </a></ng-template>
                    <ng-template #staticTitle>
                        <ng-container *ngTemplateOutlet="titleRow context: { event: event}"></ng-container>
                    </ng-template>
                    <span class="preview-row__type">{{event.customFields?.ti8m_eventtypeid?.Name || ''}}</span>
                </td>
                <td class="preview-row__date">{{ this.labelsService.getDateString(event, IncludeTime.Never) }}</td>
                <td class="preview-row__date">{{ this.labelsService.getTimeString(event) }}</td>
                <td class="preview-row__location"><i *ngIf="event.building  && event.building.name" class="fa fa-map-marker" aria-hidden="true"></i>
                    <span>{{ (event.building && event.building.name) ? event.building.name : '' }}</span></td>
                <td class="preview-row__compact">
                    <p>{{ this.labelsService.getDateString(event, IncludeTime.Never) }}</p>
                    <p>{{ this.labelsService.getTimeString(event) }}</p>
                    <p *ngIf="event.building  && event.building.name"><i class="fa fa-map-marker" aria-hidden="true"></i>
                        <span>{{ event.building.name }}</span></p>
                </td>
            </tr>
            </tbody>
        </table>
        <ng-container *ngIf="hasInternalLink()">
            <div class="row text-center my-5">
                <div class="col-12">
                    <a class="button button--text" [routerLink]="['/internalRedirect']" [queryParams]="{ internalUrl: internalEventPage}"><span class="button__text" [appTranslate]="'GoToAllEvents'">Alle Events</span></a>
                </div>
            </div>
        </ng-container>
    </div>
    <section *ngIf="allEvents && !allEvents.length" class="section section--bg-light c-text">
        <div class="row text-center mb-4">
            <div class="col-12">
                <h3 [appTranslate]="'AvailableEvents'">AvailableEvents</h3>
            </div>
        </div>
        <div class="section__container">
            <div class="c-text__wrapper text-center">
                <div class="c-text__content">
                    <p [appTranslate]="'NoEvents'">No Events</p>
                </div>
            </div>
        </div>
    </section>
</div>

<ng-template #titleRow let-event="event">
    <div class="preview-row__title" title="{{ event.eventName }}" [attr.aria-label]="getAreaLabel(event)">
        <h4>{{ event.eventName }}</h4>
    </div>
</ng-template>
